import { NgModule } from '@angular/core';
import { MenuModule } from 'primeng/menu';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { BadgeModule } from 'primeng/badge';

@NgModule({
  declarations: [],
  imports: [
    InputGroupModule,
    InputGroupAddonModule,
    InputNumberModule,
    InputTextModule,
    MenuModule,
    ButtonModule,
    TableModule,
    TabsModule,
    RippleModule,
    ProgressSpinnerModule,
    BadgeModule
  ],
  exports: [
    InputGroupModule,
    InputGroupAddonModule,
    InputNumberModule,
    InputTextModule,
    MenuModule,
    ButtonModule,
    TableModule,
    TabsModule,
    RippleModule,
    ProgressSpinnerModule,
    BadgeModule
  ]
})
export class PrimengModule {}
